module.exports = __webpack_public_path__ + "assets/img/error-dark.aabc5459.svg";